import { render, staticRenderFns } from "./SendApplicationStatusAdmin.vue?vue&type=template&id=86b77f64"
import script from "./SendApplicationStatusAdmin.vue?vue&type=script&lang=js"
export * from "./SendApplicationStatusAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports